import React, { StatelessComponent } from 'react';
import classNames from 'classnames';

/**
 * <TabList
 *  small={false}
 *  inline={false}
 *  >
 *  <TabListItem active={false}>Hello</TabListItem>
 *  <TabListItem active={true}>World</TabListItem>
 * </TabList>
 */

interface TabListItemProps {
  active: boolean;
  children: string;
  // TODO replace any with propper type. (add it as hack to be able to build itier-merchant-inbound-acquisition)
  onClick?: React.MouseEventHandler<any>;
}

export const TabListItem: StatelessComponent<TabListItemProps> = ({
  active,
  children,
  onClick,
}) => (
  <li className="mx-tab-item" onClick={onClick}>
    <input type="radio" className="mx-tab-radio" checked={active} />
    <label className="mx-tab-label">{children}</label>
  </li>
);

interface TabListProps {
  small?: boolean;
  inline?: boolean;
  children: Array<React.ReactElement<typeof TabListItem>>;
}

export const TabList: StatelessComponent<TabListProps> = ({ small, inline, children }) => (
  <ul
    className={classNames('mx-tab-list', {
      'mx-tab-list-small': small,
      'mx-tab-list-inline': inline,
    })}
  >
    {children}
  </ul>
);
